import React, { memo } from "react";

import {
  ROUTE_FINANCIAL_DETAIL,
  ROUTE_FINANCIAL_FACTOR_DETAIL,
} from "../../../../../routes";

import { paymentStatus } from "../../../../../libs/getConstants";

import ButtonComponent from "../../../../public/button";

import {
  UserOrdersTable,
  UserOrdersTableBody,
  UserOrdersTableHead,
  StatusFinancialBadge,
} from "./styledUserFinancialListPersonalComponent";

function UserFinancialListPersonalComponent({ financialData }) {
  const paymentStatusConstants = paymentStatus();
  return (
    <div className="overflow-auto">
      <UserOrdersTable className="w-100 mt-5">
        <UserOrdersTableHead>
          <tr>
            <th className="p-3">نوع خرید</th>
            <th className="p-3">وضعیت</th>
            <th className="p-3" colSpan={3}>
              مبلغ
            </th>
          </tr>
        </UserOrdersTableHead>
        <tbody>
          {financialData?.map((financialItem) => {
            const isPersonal = !financialItem.education;
            // financialItem.status === 1 is for not paid carts (new)
            if (isPersonal && financialItem.status !== 1)
              return (
                <UserOrdersTableBody key={financialItem?.id}>
                  <td className="p-3">{isPersonal ? "شخصی" : "سازمانی"}</td>
                  <td className="p-3">
                    <StatusFinancialBadge>
                      {paymentStatusConstants[financialItem.status]}
                    </StatusFinancialBadge>
                  </td>
                  <td className="p-3">{financialItem.total}</td>
                  <td className="py-3">
                    <ButtonComponent
                      isLink={true}
                      to={`${ROUTE_FINANCIAL_FACTOR_DETAIL}/${financialItem.id}`}
                      variant="outline-primary"
                      className="justify-content-center  w-75"
                    >
                      مشاهده فاکتور
                    </ButtonComponent>
                  </td>
                  <td className="py-3">
                    <ButtonComponent
                      isLink={true}
                      to={`${ROUTE_FINANCIAL_DETAIL}${financialItem.id}`}
                      className="justify-content-center  w-75"
                    >
                      مشاهده سفارش
                    </ButtonComponent>
                  </td>
                </UserOrdersTableBody>
              );
          })}
        </tbody>
      </UserOrdersTable>
    </div>
  );
}

export default memo(UserFinancialListPersonalComponent);
